module.exports = __webpack_public_path__ + "static/media/geyser.e0619619.svg";